import {baseStagingConfig} from '../base/staging.config';
import {cnetQaConfig} from './qa.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cnetStagingConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseStagingConfig, cnetQaConfig, {
  environmentName: "Cnet Staging Environment",
  ionicEnvName: 'staging',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cnet/staging.config.ts